// 빠르게 알아보기(게스트 견적) 옵션 - platform ParlorRequestBox와 동일한 값
// 값(label)이 곧 서버 전송 값. status만 getSangjoQuotationStatus로 리맵.
export const URGENCY_OPTIONS = [
  "급하지 않지만 미리 알아보려고 해요.",
  "1주에서 한 달 정도 기간이 남은 것 같아요.",
  "임종이 며칠 남지 않았어요.",
  "임종하신 상태입니다.",
];

export const CONDOLER_OPTIONS = [
  "0명(무빈소)",
  "50명 내외",
  "100명 내외",
  "200명 이상",
  "모르겠어요",
];

// platform sangjoQuotation.ts getSangjoQuotationStatus와 동일 (2개 값만 서버용으로 변환)
export const getSangjoQuotationStatus = (status: string) => {
  if (status === "1주에서 한 달 정도 기간이 남은 것 같아요.")
    return "1달 정도 기간이 남은 것 같아요.";
  if (status === "임종이 며칠 남지 않았어요.") return "임종이 얼마 남지 않았어요.";
  return status;
};
